
import NewsItem from '@/components/blocks/newsItem.vue';
import Slider from '@/components/ui/slider.vue';

export default {
  name: 'News',

  components: {
    NewsItem,
    Slider,
  },

  props: {
    data: {
      type: Object,
      default: () => {},
    },
  },
};
